import phoneIcon from '../../assets/mdi_phone.svg'
import emailIcon from '../../assets/mdi_alternate-email.svg'
import linkedInIcon from '../../assets/mdi_linkedin.svg'
import house from '../../assets/mdi_house.svg'
import { t } from 'i18next'

export function Contact() {
  return(
    <section id="contact">
    <div className="content-wrapper flow-content flow-content--small">
      <h2>{t('contact-title')}</h2>
      <div className="center">
        <h3>Simon Renlund tmi</h3>
        <h3>3460946-3</h3>
      </div>
      <ul className="center no-deco">
        <li className="flex"><img className="icon-inline" src={emailIcon} alt="e-mail icon"></img>simon[at]renlund.fi</li>
        <li className="flex"><img className="icon-inline" src={phoneIcon} alt="phone icon"></img>+358 46 802 6380</li>
        <li className="flex"><img className="icon-inline" src={linkedInIcon} alt="linkedin icon"></img><a href="https://www.linkedin.com/in/simon-renlund-6596b899/" target="_blank">Simon Renlund</a></li>
        <li className="flex"><img className="icon-inline" src={house} alt="house icon"></img>Helsinki</li>
      </ul>
    </div>
  </section>
  )
}